import { ImportDetails, ImportHistory, Person } from '@/models/Person';
import { User } from '@/models/User';
import { AxiosError } from 'axios';

export enum PeopleTypes {
    GET_PEOPLE_CLEAR = '@person/GET_PEOPLE_CLEAR',
    GET_PEOPLE_REQUEST = '@person/GET_PEOPLE_REQUEST',
    GET_PEOPLE_SUCCESS = '@person/GET_PEOPLE_SUCCESS',
    GET_PEOPLE_FAILURE = '@person/GET_PEOPLE_FAILURE',

    ACTIVE_REQUEST = '@user/ACTIVE_REQUEST',
    ACTIVE_SUCCESS = '@user/ACTIVE_SUCCESS',
    ACTIVE_FAILURE = '@user/ACTIVE_FAILURE',

    FIRST_ACCESS_REQUEST = '@person/FIRST_ACCESS_REQUEST',
    FIRST_ACCESS_SUCCESS = '@person/FIRST_ACCESS_SUCCESS',
    FIRST_ACCESS_FAILURE = '@person/FIRST_ACCESS_FAILURE',

    FORGOT_PASSWORD_REQUEST = '@user/FORGOT_PASSWORD_REQUEST',
    FORGOT_PASSWORD_SUCCESS = '@user/FORGOT_PASSWORD_SUCCESS',
    FORGOT_PASSWORD_FAILURE = '@user/FORGOT_PASSWORD_FAILURE',

    POST_PERSON_REQUEST = '@person/POST_PERSON_REQUEST',
    POST_PERSON_SUCCESS = '@person/POST_PERSON_SUCCESS',
    PUT_PERSON_REQUEST = '@person/PUT_PERSON_REQUEST',
    PUT_PERSON_SUCCESS = '@person/PUT_PERSON_SUCCESS',
    HANDLE_PERSON_FAILURE = '@person/HANDLE_PERSON_FAILURE',
    HANDLE_PERSON_CLEAR = '@person/HANDLE_PERSON_CLEAR',

    GET_PERSON_REQUEST = '@person/GET_PERSON_REQUEST',
    GET_PERSON_SUCCESS = '@person/GET_PERSON_SUCCESS',
    GET_PERSON_FAILURE = '@person/GET_PERSON_FAILURE',
    GET_PERSON_CLEAR = '@person/GET_PERSON_CLEAR',

    GET_IMPORT_HISTORY_REQUEST = '@person/GET_IMPORT_HISTORY_REQUEST',
    GET_IMPORT_HISTORY_SUCCESS = '@person/GET_IMPORT_HISTORY_SUCCESS',
    GET_IMPORT_HISTORY_FAILURE = '@person/GET_IMPORT_HISTORY_FAILURE',
    GET_IMPORT_HISTORY_CLEAR = '@person/GET_IMPORT_HISTORY_CLEAR',

    GET_IMPORT_DETAIL_REQUEST = '@person/GET_IMPORT_DETAIL_REQUEST',
    GET_IMPORT_DETAIL_SUCCESS = '@person/GET_IMPORT_DETAIL_SUCCESS',
    GET_IMPORT_DETAIL_FAILURE = '@person/GET_IMPORT_DETAIL_FAILURE',
    GET_IMPORT_DETAIL_CLEAR = '@person/GET_IMPORT_DETAIL_CLEAR',

    GET_TOTAL_ACTIVE_PEOPLE_REQUEST = '@person/GET_TOTAL_ACTIVE_PEOPLE_REQUEST',
    GET_TOTAL_ACTIVE_PEOPLE_SUCCESS = '@person/GET_TOTAL_ACTIVE_PEOPLE_SUCCESS',
    GET_TOTAL_REGISTERED_PEOPLE_SUCCESS = '@person/GET_TOTAL_REGISTERED_PEOPLE_SUCCESS',
    GET_TOTAL_ACTIVE_PEOPLE_FAILURE = '@person/GET_TOTAL_ACTIVE_PEOPLE_FAILURE',

    REFRESH_MY_PERSON_REQUEST = '@person/REFRESH_MY_PERSON_REQUEST',
    REFRESH_MY_PERSON_SUCCESS = '@person/REFRESH_MY_PERSON_SUCCESS',
    REFRESH_MY_PERSON_FAILURE = '@person/REFRESH_MY_PERSON_FAILURE',

    GET_PUBLIC_PERSON_REQUEST = '@person/GET_PUBLIC_PERSON_REQUEST',
    GET_PUBLIC_PERSON_SUCCESS = '@person/GET_PUBLIC_PERSON_SUCCESS',
    GET_PUBLIC_PERSON_FAILURE = '@person/GET_PUBLIC_PERSON_FAILURE',
    GET_PUBLIC_PERSON_CLEAR = '@person/GET_PUBLIC_PERSON_CLEAR',
}

export interface ListViewPeopleData {
    list: Person[];
    total: number;
    loading: boolean;
}

export interface People {
    listOfPeople: ListViewPeopleData;
    listOfUser: User[];
    importHistory?: [ImportHistory];
    importDetails?: [ImportDetails];
    importDetailsTotal?: number;
}

export interface PersonState {
    person: Person;
    user?: User;
}

export interface PeopleState {
    data: People;
    person?: PersonState;
    publicPerson?: Person;
    totalActives: number;
    totalRegistered: number;
    loading: boolean;
    hasError: boolean;
    error?: AxiosError;
    success: boolean;
    processingActivation: boolean;
    myPerson?: Person;
    successOnPutPerson?: boolean;
}

export interface PersonResponse {
    person: Person;
    user: User;
}
